import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreStrategiesRoutes = [
  {
    path: 'strategies',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Strategies')
      },
      permissions: ['READ_RORE_STRATEGIES']
    },
    children: [
      {
        path: '',
        name: 'roreStrategiesList',
        component: wrapLegacyRoute('roreStrategiesController', 'list')
      },
      {
        path: 'create',
        name: 'roreStrategyCreate',
        component: wrapLegacyRoute('roreStrategiesController', 'create')
      },
      {
        path: ':strategyId(\\d+)',
        name: 'roreStrategyDetails',
        component: wrapLegacyRoute('roreStrategiesController', 'details')
      }
    ]
  }
];

export default roreStrategiesRoutes;
